export default {
  navigationBarTitleText: '设置权限',
};
